// Shared enum for feature usage origins (keep in sync with BE)
export enum FeatureUsageOrigin {
  PortalOverview = 'Portal_Overview',
  PortalMySessions = 'Portal_MySessions',
  PortalServicesOverview = 'Portal_ServicesOverview',
  PortalAttendantConsole = 'Portal_AttendantConsole',
  AssistantOutbound = 'Assistant_Outbound',
  // Add more as needed
  Unknown = 'Unknown',
}
